import {remCalc} from '_themeUtils'

/**
 * ColorCircle (Figma "Color dots", VARIANTE NUOVA) — two-ring swatch:
 * - `outerRing` fills the parent wrapper and provides the gap (padding) + the light-grey outer
 *   ring, which is only visible when `selected` (transparent otherwise).
 * - `cirle` is the inner colour dot filling the padded area, always carrying the dark stroke.
 *
 * The consumer sets the OUTER size on its wrapper; the inner dot sizes itself to what remains
 * after the 3px gap.
 */
const colorCirle = {
    ColorCirle: {
        baseStyle: ({selected}: {selected?: boolean}) => ({
            outerRing: {
                // Every current consumer supplies a positioned, fixed-size 24px/26px host.
                // Absolute inset sizing avoids Safari's percentage-height resolution in flex items.
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                p: remCalc(3),
                border: '1px solid',
                borderColor: selected ? 'color.border.grey.400' : 'color.border.transparent',
                boxSizing: 'border-box',
            },
            cirle: {
                position: 'relative',
                w: '100%',
                h: '100%',
                overflow: 'hidden',
                borderRadius: '50%',
                border: '1px solid',
                borderColor: 'color.border.black',
                boxSizing: 'border-box',
            },
        }),
    },
}

export default colorCirle
